import { render } from "./SentimentsMiniGuide.vue?vue&type=template&id=85902714"
import script from "./SentimentsMiniGuide.vue?vue&type=script&lang=js"
export * from "./SentimentsMiniGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__